import { Component, AfterViewInit, ViewChild, Inject } from '@angular/core';
import { MedicalData, UserData, MedicalDataContainer, keyvaluepair, MedicalsSubData} from "../../model/index"
import { MedicalReportService } from '../Service/MedicalReport.Service';
import { Title } from '@angular/platform-browser';
import { SecurityService } from '../../Security/security.service';
import { Router } from "@angular/router";
import { ModalComponent } from "../../shared/modeldialog/index";
import { jsPDF } from "jspdf";

declare var require: any;
declare var MedicalGrid: any;
declare let html2canvas: any;
declare let jspdf: any;

@Component({
    selector: 'MentisSoft-MedicalReport',
    template: require('../Template/MedicalReport.template.html'),
    styles: [require('../Template/MedicalReport.css')],
})


export class MedicalReportComponent implements AfterViewInit {
    @ViewChild("loadingindicator") loadingindicator: ModalComponent;
    @ViewChild("medicalreportPopup") medicalreportPopup: ModalComponent;
    constructor(@Inject(SecurityService) private _SecurityService: SecurityService, private _titleService: Title, private _medicalReportService: MedicalReportService,
        private router: Router) {
        MedicalGrid = this;
    }

    ReportDate: string;
    doctorName: string;
    doctorList: string[] = [];
    Date: string[] = [];
    pid: any;
    dataSource: MedicalData[] = [];
    LabFilter: MedicalData = new MedicalData();
    medicalResult: MedicalsSubData[] = [];
    medicalsubResult: MedicalsSubData = new MedicalsSubData();
    columns: any[] = [];
    bFiltersLoaded: boolean = false;
    count: number;
    loading = false;

    ReportNo: string = "";
    DeptName: string = "";;
    OPIPNO: string = "";
    CategoryName: string = "";
    SponsorName: string = "";;
    PatientName: string = "";
    ReportDoctorName: string = "";
    MedicaReportDate: string;
    Gender: string = "";
    PatientId: string = "";
    DateOfBirth: string = "";
    MedicalReport: string="";

    ngAfterViewInit(): void {
        $('#overlay').hide();
        this.LoadMedicalRecord();
    }
    ngOnInit() {
        this.loading = false;
    }
    LoadMedicalRecord() {
        this.loading = true;
        var userInfo: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
        this.pid = this._SecurityService.pid;
        this._medicalReportService.getMedicalRecord(userInfo)
            .subscribe(
                p => {
                    if (p != null && p.sessionExpiry && p.SessionTimeout != "Session Expired") {
                        this.loading = false;
                        this.dataSource = p.MedicalReports;


                        if (!this.bFiltersLoaded) {
                            this.buildFilters();
                        }
                        this.bFiltersLoaded = true;

                        this.buildGrid(this.dataSource);

                        this._SecurityService.errorMessage = "";
                    }

                    else if (!p.sessionExpiry || p.SessionTimeout == "Session Expired") {
                        this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                        this.router.navigate(["/Login"]);
                    }
                },
                err => {
                    this.loading = false;
                    console.log("Error while validating...");
                });
    }

    buildFilters() {
        this.getDistinctDoctors();
        this.getDistinctDates();
    }

    getDistinctDates() {
        this.Date.push("All");
        if (this.dataSource != null) {
            for (var i = 0; i < this.dataSource.length; i++) {
                if (this.Date.indexOf(this.dataSource[i].REPORT_DATE) == -1) {
                    this.Date.push(this.dataSource[i].REPORT_DATE);
                }
            }
        }
    }
    getDistinctDoctors() {
        this.doctorList = [];
        this.doctorList.push("All");
        if (this.dataSource != null) {
            for (var i = 0; i < this.dataSource.length; i++) {
                if (this.doctorList.indexOf(this.dataSource[i].doctorName) == -1) {
                    this.doctorList.push(this.dataSource[i].doctorName);
                }
            }
        }
    }
    public buildGrid(data) {
        try {
            this.buildColumn();

            var dgrid = jQuery("#grdMedicalResults").data("kendoGrid");
            if (dgrid) {
                $('#grdMedicalResults').data().kendoGrid.destroy();
                $('#grdMedicalResults').empty();
            }
            jQuery('#grdMedicalResults').kendoGrid({
                editable: false,
                filterable: true,
                pageable: {
                    pageSizes: [10, 25, 50, 100]
                },
                scrollable: false,
                sortable: true,

                columns: this.columns,
                filterMenuInit: function (e) {
                    if (e.field != "SubmissionID" && e.field != "NameInsuredOrTreatyTitle") {
                        var filterMultiCheck = e.sender.thead.find("[data-field=" + e.field + "]").data("kendoFilterMultiCheck");
                        filterMultiCheck.container.empty();
                        var chkSourceData = filterMultiCheck.checkSource.data();

                        chkSourceData.sort(function (a: any, b: any) {
                            var sortStatus = 0;

                            if (a[e.field].toLowerCase() < b[e.field].toLowerCase()) {
                                sortStatus = -1;
                            } else if (a[e.field].toLowerCase() > b[e.field].toLowerCase()) {
                                sortStatus = 1;
                            }

                            return sortStatus;
                        });

                        filterMultiCheck.checkSource.data(chkSourceData.toJSON());
                        filterMultiCheck.createCheckBoxes();
                    }
                },

                dataBinding: this.databinding,

                dataSource: {
                    data: data,
                    pageSize: this.dataSource != null ? 10 : 0,
                    sort: [{
                        field: "ProfitCenter",
                        dir: "asc"
                    }, {
                        field: "Department",
                        dir: "asc"
                    }, {
                        field: "Modified",
                        dir: "desc"
                    }],
                },
            });
            jQuery("#grdMedicalResults").data("kendoGrid").wrapper.children(".k-grid-pager").find("span.k-input").html('All');
            var gridPage = jQuery("#grdMedicalResults").data("kendoGrid");
            gridPage.wrapper.children(".k-grid-pager").find("span.k-input").html('10');
            var pageSizeDropDownList = gridPage.wrapper.children(".k-grid-pager").find("select").data("kendoDropDownList");
            pageSizeDropDownList.bind("change", function (e: any) {
                gridPage.wrapper.children(".k-grid-pager").find("span.k-input").html(gridPage.wrapper.children(".k-grid-pager").find("select").find('option:selected').text());
            });
        }
        catch (ex) {
            this.handleError(ex);
        }
    }

    databinding(e: any) {
        try {
            var grid = jQuery("#grdMedicalResults").data("kendoGrid");
            var totalCount = grid.dataSource.total();
            this.count = totalCount;
            var pageSizes = [{ text: "10", value: 10 }, { text: "25", value: 25 }, { text: "50", value: 50 }, { text: "100", value: 100 }, { text: "All", value: totalCount }];
            var pagerdropdownBox = jQuery('.k-pager-sizes select[data-role="dropdownlist"]').data('kendoDropDownList');
            var pagerds = new kendo.data.DataSource({
                data: pageSizes
            });
            pagerdropdownBox.setDataSource(pagerds);
        }
        catch (e) {

        }
    }
    buildColumn(): void {

        this.columns = [
            {
                field: "",
                title: "",
                template: kendo.template("#=this.buildLabReportRow(REPORT_DATE,MedicalsSubData,doctorName)#").bind(this)
            }
        ];
    }

    onChange(event) {
        this.LoadFilterReports();
    }

    LoadFilterReports() {
        if (this.dataSource != null) {
            let labFilters: keyvaluepair[] = [];

            for (var f in this.LabFilter) {
                if (this.LabFilter[f] != undefined && this.LabFilter[f] != null && this.LabFilter[f] != 'All') {
                    let kv: keyvaluepair = new keyvaluepair();
                    kv.key = f;
                    kv.value = this.LabFilter[f];
                    labFilters.push(kv);
                }
            }

            this.buildGrid(this.getFilteredDataSource(labFilters));
        }
    }

    getFilteredData(ds: MedicalData[], filter: keyvaluepair): MedicalData[] {
        let count;
        let dsFiltered: MedicalData[] = [];
        let dssubdata: MedicalsSubData = new MedicalsSubData();
        if (filter != null && ds != null && ds.length > 0) {
            for (let d in ds) {
                count = 0;
                if (filter.key == "TestName" || filter.key == "Status") {
                    for (var d1 in ds[d].MedicalsSubData) {
                        for (var d2 in ds[d].MedicalsSubData[d1]) {
                            if (filter.key == d2) {
                                if (filter.value == ds[d].MedicalsSubData[d1][d2]) {
                                    count++;
                                    dssubdata = ds[d].MedicalsSubData[d1];
                                    if (count < 2) {
                                        dsFiltered.push(ds[d]);
                                    }


                                }
                            }
                        }
                    }
                }
                else {
                    for (var d1 in ds[d]) {
                        if (filter.key == d1) {
                            if (filter.value == ds[d][d1]) {
                                dsFiltered.push(ds[d]);
                            }
                        }
                    }
                }
            }
        }
        return dsFiltered;
    }

    getFilteredDataSource(filter: keyvaluepair[]): MedicalData[] {
        let ds: MedicalData[] = this.dataSource;
        if (filter != null && filter.length > 0) {
            for (let i = 0; i < filter.length; i++) {
                ds = this.getFilteredData(ds, filter[i]);
            }
        }
        return ds;
    }

    buildLabReportRow(ReportDate: string, MedicalSubsData: MedicalsSubData[], DoctorName: string): string {
        this.ReportDate = ReportDate;
        this.doctorName = DoctorName;
        var  ReportNo: string;
        var row1 = "";
        var line1 = "<div class='resultstablewrap'> <div class='visit_wrap' > <div class='doctor_date'><span class='dateG'> <i class='fa fa-calendar-check-o' aria- hidden='true' > </i>" + ReportDate + " </span>";
        var line2 = " <span class='pull-right' > <strong>Dr.</strong>" + DoctorName + "</span ></div> ";
        var line3 = "</div > </div>";

        if (MedicalSubsData && MedicalSubsData.length > 0) {
            var row;

            for (var i = 0; i < MedicalSubsData.length; i++) {
                ReportNo = MedicalSubsData[i].REPORT_NO;

                var r1 = "<div class='resson_visit' > <span>" + 'Medical Report No: '+MedicalSubsData[i].REPORT_NO + "</span > ";
                var r5 = "<a class='small_btn def_btn view_resultbtn pull-right' onclick=MedicalGrid.ViewReport('" + ReportNo  + "')> <i class='fa fa-file-text' aria- hidden='true' > </i > Results </a>  </span > </div>";
                row = r1 + r5;
                row1 = row1.concat(row);
            }
        }
        return line1 + line2 + row1 + line3;
    }

    ViewReport(ReportNo) {
        //this.LoadMedicalResults(instruction);
        this.LoadMedicalResults(ReportNo);
    }

    LoadMedicalResults(ReportNo) {
        for (var i = 0; i < this.dataSource.length; i++) {
            for (var j = 0; j < this.dataSource[i].MedicalsSubData.length; j++) {
                if (this.dataSource[i].MedicalsSubData[j].REPORT_NO == ReportNo) {
                    this.ReportDoctorName = this.dataSource[i].MedicalsSubData[j].DoctorName;
                    this.PatientId = this.dataSource[i].MedicalsSubData[j].PATIENT_ID;
                    this.PatientName = this.dataSource[i].MedicalsSubData[j].PatientName;
                    this.ReportNo = this.dataSource[i].MedicalsSubData[j].REPORT_NO;
                    this.Gender = this.dataSource[i].MedicalsSubData[j].Gender;
                    this.DateOfBirth = this.dataSource[i].MedicalsSubData[j].DateOfBirth;
                    this.MedicaReportDate = this.dataSource[i].MedicalsSubData[j].REPORT_DATE;
                    this.SponsorName = this.dataSource[i].MedicalsSubData[j].SponsorName;
                    this.CategoryName = this.dataSource[i].MedicalsSubData[j].CATEGORYNAME;
                    this.OPIPNO = this.dataSource[i].MedicalsSubData[j].OPORIPNo;
                    this.DeptName = this.dataSource[i].MedicalsSubData[j].DeptName;
                    this.MedicalReport = this.dataSource[i].MedicalsSubData[j].MEDICAL_REPORT;
                    this.medicalreportPopup.open();
                }
            }
        }
    }

    //LoadLabInstructions(ReportNo) {
    //    this.loading = true;
    //    //this.loadingindicator.open();
    //    this.medicalResult = [];
    //    var userInfo: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
    //    //this.ReportDoctorName = "jhjlkhkhlkljhkjhkh12123";
        
    //    userInfo.ReqNo = ReportNo;
    //    userInfo.pid = this._SecurityService.pid;
    //    this._medicalReportService.getMedicalResults(userInfo)
    //        .subscribe(
    //            p => {
    //                if (p != null && p.sessionExpiry && p.SessionTimeout != "Session Expired") {
    //                    this._SecurityService.errorMessage = "";
    //                    this.loading = false;
    //                    //this.ReportDoctorName = "jhjlkhkhlkljhkjhkh4455656";
    //                    this.medicalsubResult = p.MedicalSubData[0];
    //                   // this.ReportDoctorName = "78678687687678";
    //                    //this.medicalreportPopup.open();
    //                    if (p.MedicalSubData.length > 0) {
    //                        this.ReportDoctorName =  p.MedicalSubData[0].DoctorName;
    //                        this.PatientId = p.MedicalSubData[0].PATIENT_ID;
    //                        this.PatientName = p.MedicalSubData[0].PatientName;
    //                        this.ReportNo = p.MedicalSubData[0].REPORT_NO;
    //                        this.Gender = p.MedicalSubData[0].Gender;
    //                        this.DateOfBirth = p.MedicalSubData[0].DateOfBirth;
    //                        this.MedicaReportDate = p.MedicalSubData[0].REPORT_DATE;
    //                        this.SponsorName = p.MedicalSubData[0].SponsorName;
    //                        this.CategoryName = p.MedicalSubData[0].CATEGORYNAME;
    //                        this.OPIPNO = p.MedicalSubData[0].OPORIPNo;
    //                        this.DeptName = p.MedicalSubData[0].DeptName;
    //                        this.MedicalReport = p.MedicalSubData[0].MEDICAL_REPORT;
    //                        //this.medicalsubResult.DoctorName = p.MedicalSubData[0].DoctorName;
    //                        //this.medicalsubResult.PATIENT_ID = p.MedicalSubData[0].PATIENT_ID;
    //                        //this.medicalsubResult.PatientName = p.MedicalSubData[0].PatientName;
    //                        //this.medicalsubResult.REPORT_NO = p.MedicalSubData[0].REPORT_NO;
    //                        //this.medicalsubResult.Gender = p.MedicalSubData[0].Gender;
    //                        //this.medicalsubResult.DateOfBirth = p.MedicalSubData[0].DateOfBirth;
    //                        //this.medicalsubResult.REPORT_DATE = p.MedicalSubData[0].REPORT_DATE;
    //                        //this.medicalsubResult.SponsorName = p.MedicalSubData[0].SponsorName;
    //                        //this.medicalsubResult.CATEGORYNAME = p.MedicalSubData[0].CATEGORYNAME;
    //                        //this.medicalsubResult.OPORIPNo = p.MedicalSubData[0].OPORIPNo;
    //                        //this.medicalsubResult.SequenceNo = p.MedicalSubData[0].SequenceNo;
    //                        //this.medicalsubResult.MEDICAL_REPORT = p.MedicalSubData[0].MEDICAL_REPORT;
    //                        this.medicalreportPopup.open();
    //                    }
    //                    else {         
    //                        this.loading = false;                   
    //                        console.log("data not recieved");
    //                    }
    //                }

    //                else if (!p.sessionExpiry || p.SessionTimeout == "Session Expired") {
    //                    this.loading = false;
    //                    window.document.getElementById("closeBtn").click();
    //                    this._SecurityService.errorMessage = "Your session has expired. Please login again.";
    //                    this.router.navigate(["/Login"]);
    //                }
    //            },
    //            err => {
    //                this.loading = false;
    //                console.log("Error while validating...");
    //            });
    //    this.loading = false;
    //}

    labResultPdf123(): void {
        const doc = new jsPDF('p', 'pt', 'a4');
        var downname = 'MedicalReport_' + new Date().getDate() + new Date().getMonth() + new Date().getFullYear() + new Date().getHours() + new Date().getMinutes() + new Date().getMilliseconds() + '.pdf';
        doc.html(document.getElementById("Html5Pdf1"), {
            callback: function (doc) {
                doc.save(downname);
            }
        })
    }

    private handleError(error: any) {
        console.log("error : " + error);
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/MedicalReport/Component/MedicalReport.Component.ts